/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { HistoryDto } from '../../models/history-dto';

export interface HistoryClientControllerFindAllV1$Params {
}

export function historyClientControllerFindAllV1(http: HttpClient, rootUrl: string, params?: HistoryClientControllerFindAllV1$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<HistoryDto>>> {
  const rb = new RequestBuilder(rootUrl, historyClientControllerFindAllV1.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<HistoryDto>>;
    })
  );
}

historyClientControllerFindAllV1.PATH = '/api/v1/histories/client';
